const customSelectButtons = document.querySelectorAll('.js-custom-select-btn');

customSelectButtons.forEach((button) => {
  const selectWrapper = button.closest('.js-custom-select');
  let dropDown = selectWrapper.querySelector('.js-custom-select-dropdown');
  const selectField = selectWrapper.querySelector('.js-custom-select-field');
  const options = dropDown.querySelectorAll('.js-custom-select-option');

  // Toggle dropdown
  button.addEventListener('click', (e) => {
    e.preventDefault();

    if (button.classList.contains('active')) {
      // Close select dropdown
      closeCustomSelectDropdown(button, dropDown);
    } else {
      // Open select dropdown
      openCustomSelectDropdown(button, dropDown);
    }
  });

  // Close dropdown on click outside
  document.addEventListener('click', (e) => {
    const clickInsideWrapper = selectWrapper.contains(e.target);

    if (!clickInsideWrapper) {
      closeCustomSelectDropdown(button, dropDown);
    }
  });

  // Select option
  options.forEach((option) => {
    option.addEventListener('click', () => {
      const optionText = option.innerHTML;
      const optionValue = option.dataset.optValue;

      setOption(button, dropDown, selectField, optionText, optionValue);
    });
  });
});

/**
 * Set dropdown value
 *
 * @param {HTMLElement} button
 * @param {HTMLElement} dropDown
 * @param {HTMLElement} selectField
 * @param {string} optionText
 * @param {string} optionValue
 */
function setOption(button, dropDown, selectField, optionText, optionValue) {
  // Set hidden select field value
  selectField.value = optionValue;

  // Trigger change event
  selectField.dispatchEvent(new Event('change'));

  // Set button value
  const textEl = button.querySelector('.js-custom-select-btn-text');
  textEl.innerHTML = optionText;

  closeCustomSelectDropdown(button, dropDown);
}

/**
 * Open dropdown
 *
 * @param {HTMLElement} button
 * @param {HTMLElement} dropDown
 */
function openCustomSelectDropdown(button, dropDown) {
  // Set dropdown max height by inner options list height
  const dropDownList = dropDown.querySelector('.js-custom-select-dropdown-list');
  const dropDownListStyle = window.getComputedStyle(dropDownList, null);
  const dropDownListHeight =
    dropDownListStyle.getPropertyValue('height') < 320 ? dropDownListStyle.getPropertyValue('height') : 320;
  dropDown.style.maxHeight = `${parseInt(dropDownListHeight)}px`;

  button.classList.add('active');
  dropDown.classList.add('active');
}

/**
 * Close dropdown
 *
 * @param {HTMLElement} button
 * @param {HTMLElement} dropDown
 */
function closeCustomSelectDropdown(button, dropDown) {
  button.classList.remove('active');
  dropDown.classList.remove('active');
}
